import { useState, useEffect } from 'react';

import useAuthenticatedAPIServiceCall from '@frolight/hooks/useAuthenticatedAPIServiceCall';
import * as peripheralService from '@frolight/services/api/peripheralService';

const usePeripheralInfoData = (peripheralDeviceIds) => {

  const [ loading, setLoading ] = useState(true);
  const [ data, setData ] = useState(null);
  const [ error, setError ] = useState(null);

  const authenticatedAPIServiceCall = useAuthenticatedAPIServiceCall();

  useEffect(() => {
    let mounted = true;

    const getPeripheralInfoAbortController = new AbortController();
    const getPeripheralInfo = async () => {
      if (mounted) setLoading(true);

      try {
        const peripherals = await authenticatedAPIServiceCall(
          peripheralService.getPeripheralInfoByDeviceIds,
          {
            abortController: getPeripheralInfoAbortController,
            opts: {
              peripheralDeviceIds: peripheralDeviceIds
            }
          }
        );

        if (mounted) setData(peripherals.data);
      } catch (err) {
        if (err.name !== 'AbortError') {
          if (mounted) setError(err);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    }

    if (peripheralDeviceIds) {
      getPeripheralInfo();
    }

    return () => {
      mounted = false;
      getPeripheralInfoAbortController.abort();
    }

  }, [ peripheralDeviceIds ]);

  return { loading, error, data };
};

export default usePeripheralInfoData;